<template>
    <div v-skeleton="features" class="features">
        <div v-for="(feature, index) in featuresWithIcon" :key="'feature' + index" class="features__item">
            <IconSvg :filepath="getIconUrl(feature.webname)" class="features__item-icon">
                <title>{{ feature.text }}</title>
            </IconSvg>
            <p class="features__item-text">{{ feature.text }}</p>
        </div>
    </div>
</template>

<script>
import skeleton from '@/directives/skeleton';

export default {
    name: 'FeatureIcons',
    directives: { skeleton },
    data() {
        return {
            dict: {
                'haustiere-erlaubt': 'hund.svg',
                'hunde-willkommen': 'hund.svg',
                'pets-welcome': 'hund.svg',

                parkplatz: 'parkplatz.svg',
                parking: 'parkplatz.svg',
                garage: 'parkplatz.svg',
                'garage-engl': 'parkplatz.svg',

                restaurant: 'restaurant.svg',
                'restaurant-eng': 'restaurant.svg',

                barrierefrei: 'barrierefrei.svg',
                'barrier-free': 'barrierefrei.svg',

                'oepnv-in-500m-entfernung': 'opnv.svg',
                'public-transport-near': 'opnv.svg',

                fitness: 'fitness.svg',
                'fitness-area': 'fitness.svg',

                'pool-innen': 'pool.svg',
                pool: 'pool.svg',

                'internet-kostenlos': 'internet.svg',
                'internet-w-lan': 'internet.svg',
                'internet-included': 'internet.svg',

                sauna: 'sauna.svg',
                'sauna-engl': 'sauna.svg',

                tennis: 'tennis.svg',

                whirpool: 'whirlpool.svg',

                golf: 'golf.svg',

                'honden-welkom': 'hund.svg',
                'parking-nl': 'parkplatz.svg',
                'garage-nl': 'parkplatz.svg',
                'restaurant-nl': 'restaurant.svg',
                barrierevrij: 'barrierefrei.svg',
                'openbaar-vervoer-500m': 'opnv.svg',
                'fitness-nl': 'fitness.svg',
                'pool-nl': 'pool.svg',
                'internet-inbegrepen': 'internet.svg',
                'sauna-nl': 'sauna.svg',
                'whirpool-nl': 'whirlpool.svg'
            }
        };
    },
    props: {
        features: {
            type: Array
        }
    },
    computed: {
        featuresWithIcon() {
            return (this.features || []).filter(feature => feature.webname.toLowerCase() in this.dict);
        }
    },
    methods: {
        getIconUrl(webname) {
            return `features/${this.dict[webname.toLowerCase()]}`;
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/mixins';

.features {
    &.skeleton {
        min-height: 57px;
    }

    &__item {
        display: inline-block;
        margin: 5px 5px 0;
        font-size: 9px;
        line-height: 11px;
        text-align: center;
        width: 60px;
        max-width: 65px;
        vertical-align: top;
    }

    &__item-icon {
        margin: 0 auto 10px;
        font-size: 20px;
        color: var(--primary);
    }

    &__item-text {
        margin-bottom: 0;
    }

    @include mixins.mobile-only {
        text-align: center;
        font-size: 16px; //recommended minimal font-size is 16px on mobile

        &__item {
            width: 80px;
            max-width: 85px;
            font-size: 1em;
            margin: 10px 5px 0; // important to keep small horizontal margin for mobile. Otherwise the icons are too distant from each other
        }

        &__item-icon {
            font-size: 1.5em;
        }

        &__item-text {
            line-height: 1.2em;
        }
    }
}
</style>
